import React from 'react';
import { Switch, Route } from "wouter";

import Home from './pages/01_index';
import About from './pages/02_about/about'

import ServiceDashboard from './pages/03_servicedashboard/servicedashboard';
import WebsiteDevelopment from './pages/04_services/01_websitedevelopment/websitedevelopment';
import SEO from './pages/04_services/03_seo/seo';
import DigitalMarketingStrategy from './pages/04_services/04_digitalmarketingstrategy/digitalmarketingstrategy';
import PaidAdvertising from './pages/04_services/06_paidadvertising/paidadvertising';
import PerformanceReporting from './pages/04_services/07_performancereporting/performancereporting';

import Quotation from './pages/08_quotation/quotation';
import Contact from './pages/07_contact/contact';
import PricingPlan from './pages/10_pricing_plan/PricingPlan';
import GoogleBusinessProfile from "./pages/11_Google-business-page-pricing/GoogleBusinessPage";

import PrivacyPolicies from './pages/00_documents/privacy-policies';
import TermsConditions from './pages/00_documents/terms-conditions';

import NotFound from './assets/components/09_pagenotfound_component/09_pagenotfound_component';
import BlogDetails from './pages/09_blogs/02_blogdefault/blog';
import BlogDashboard from './pages/09_blogs/01_blogdashboard/blogdashboard';

function Router() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/about" component={About} />

      <Route path="/services" component={ServiceDashboard} />
      <Route path="/services/website-design-and-development" component={WebsiteDevelopment} />
      <Route path="/services/search-engine-optimization" component={SEO} />
      <Route path="/services/digital-marketing-strategy" component={DigitalMarketingStrategy} />
      <Route path="/services/paid-advertising" component={PaidAdvertising} />
      <Route path="/services/analytics-and-performance-reporting" component={PerformanceReporting} />
      
      <Route path="/blogdashboard" component={BlogDashboard} />
      <Route path="/blog/:id" component={BlogDetails} />

      <Route path="/contact" component={Contact} />
      <Route path="/quotation" component={Quotation} />
      <Route path="/website-pricing-plan" component={PricingPlan} />
      <Route path="/google-business-page-pricing" component={GoogleBusinessProfile} />

      <Route path="/privacy-policies" component={PrivacyPolicies} />
      <Route path="/terms-conditions" component={TermsConditions} />

      <Route path="*" component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
      <Router />
  );
}

export default App;